require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tags-تطوير-المواقع.json") })
        }
      }, "path---tags-تطوير-المواقع");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tags-تطوير-المواقع!./.cache/json/tags-تطوير-المواقع.json
// module id = 596
// module chunks = 231608221292675